<div class="card carddborder">
  <div class="card-header">
    <div class="launch-header d-flex w-100 justify-content-between align-items-center">
      <h5 class="mb-0">Instance Request Dashboard</h5>
      <div class="dashboard-header-actions">
        <button *ngIf="writeAccess" type="button" class="btn request-ec2-btn" (click)="openLaunchEc2Modal()">
          <span class="request-ec2-btn__plus">+</span>
          Request EC2
        </button>
        <button class="btn btn-light" [disabled]="loading" (click)="loadRequests()">Refresh</button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="loading" class="mapping-box">Loading requests...</div>
    <div *ngIf="!loading && error" class="alert alert-danger mb-3">{{ error }}</div>

    <div *ngIf="!loading && !error" class="mapping-box">
      <table class="table table-sm mb-0 ec2-dashboard-table">
        <thead>
          <tr>
            <th class="col-sno">S No</th>
            <th class="col-instance">Instance Type</th>
            <th class="col-requested-by">Requested By</th>
            <th class="col-price text-end">Price Per Month</th>
            <th class="col-stage">Stage</th>
            <th class="col-status">Status</th>
            <th class="col-result">Failed Reason</th>
            <th class="col-actions text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let i = index">
            <td class="col-sno">{{ i + 1 }}</td>
            <td class="col-instance">{{ row.instance_type || "-" }}</td>
            <td class="col-requested-by">{{ row.requested_by || "-" }}</td>
            <td class="col-price text-end">{{ row.price_per_month ?? "-" }}</td>
            <td class="col-stage">{{ row.stage || "-" }}</td>
            <td class="col-status">{{ row.status || "-" }}</td>
            <td class="col-result">
              <span *ngIf="row.status === 'LAUNCH_FAILED' && row.reason" class="text-break">{{ row.reason }}</span>
              <span *ngIf="row.status !== 'LAUNCH_FAILED' || !row.reason">-</span>
            </td>
            <td class="col-actions text-center">
              <a
                class="btn btn-sm btn-outline-primary details-btn"
                [routerLink]="['/dash/operations/ec2-request', row.request_id]"
                [queryParams]="detailQueryParams(row)"
              >
                Details
              </a>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0">
            <td colspan="8" class="text-center text-muted">No requests found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-ec2-launch-modal
  *ngIf="showLaunchEc2Modal"
  (close)="closeLaunchEc2Modal($event)"
></app-ec2-launch-modal>

